import React, { Component } from 'react';

import PressRelease from 'client/components/press-release';
import PressReleases from 'client/components/press-releases';
import Seo from 'client/components/seo';

import { BundleData } from 'client/bundles/types';

interface Props {
    data: BundleData;
}

export default class PressReleasesPage extends Component<Props> {
    render() {
        const { pressReleases, baseUrl, title, messages, archive } = this.props.data;
        const { item, items, years, currentYear } = pressReleases;

        const sectionTitle = title;
        const titlePage = pressReleases.item?.title ? pressReleases.item.title : `${sectionTitle} ${currentYear ? currentYear : ''}`;

        return (
            <>
                <Seo title={titlePage} />

                {item ?
                    <PressRelease
                        sectionTitle={sectionTitle}
                        item={item}
                        messages={messages}
                        currentYear={currentYear}
                        baseUrl={baseUrl}
                        /> :
                    <PressReleases
                        title={sectionTitle}
                        items={items}
                        messages={messages}
                        currentYear={currentYear}
                        baseUrl={baseUrl}
                        years={years}
                        archive={archive}
                        />
                }
            </>
        );
    }
}
